import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip, Typography, useTheme } from "@mui/material";
import { colCenter } from "../../style/style";
export const TabTitle = ({ number, title, value, index, }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: { ...colCenter, gap: 1 }, children: [_jsx(Typography, { variant: "subtitle2", fontWeight: 600, color: value === index ? theme.palette.text.primary : theme.palette.text.secondary, children: title }), _jsx(Chip, { label: number, color: "default", variant: "soft", size: "small" })] }));
};
